var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0612 13.1173L18.6932 20.8116C18.8722 20.9911 19.0849 21.1334 19.319 21.2305C19.5531 21.3276 19.804 21.3776 20.0575 21.3776C20.3109 21.3776 20.5618 21.3276 20.7959 21.2305C21.03 21.1334 21.2426 20.9911 21.4216 20.8116V20.8116C21.7817 20.4504 21.9839 19.9612 21.9839 19.4512C21.9839 18.9412 21.7817 18.452 21.4216 18.0908L13.8248 10.4316",
    stroke: "#B9BEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89918 3.37109C8.62669 3.37373 8.35488 3.39884 8.08651 3.44614L11.3882 6.7478L7.56124 10.5747L4.1223 7.1365C3.88138 8.13053 3.9563 9.17494 4.33668 10.1244C4.71707 11.0738 5.38399 11.8811 6.2446 12.4338C7.1052 12.9865 8.11671 13.2572 9.13835 13.2082C10.16 13.1592 11.1409 12.7929 11.9447 12.1603C12.7484 11.5277 13.335 10.6604 13.6227 9.67887C13.9105 8.69737 13.885 7.65058 13.5501 6.68418C13.2151 5.71778 12.5872 4.87984 11.7537 4.28697C10.9203 3.6941 9.92277 3.3758 8.89996 3.37636L8.89918 3.37109Z",
    stroke: "#B9BEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAsed);
export default __webpack_public_path__ + "static/media/icoAsed.c480079b9414fc6d3e67d56129f2e9af.svg";
export { ForwardRef as ReactComponent };